import {
  CallUsPopupForm as PageCallUsPopupForm,
  useDonationFormContext,
} from '@web/components/page-components/DonationForm'
import { useMergeFields } from '@web/components/page-components/Text/MergeTags/MergeTag'
import { CAMPAIGN_MERGE_TAGS, CHARITY_MERGE_TAGS } from '@web/components/page-components/Text/MergeTags/utils'
import { CustomFieldElementType, ExtraField, ExtraFieldType } from '@web/graphql-components'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { useSubmitFormValuesMutation } from 'apps/fe-donation/libs/queries'
import { useMemo } from 'react'
import ProfileSelector from './ProfileSelector'

const [CharityName] = CHARITY_MERGE_TAGS
const [CampaignName] = CAMPAIGN_MERGE_TAGS

const CallUsPopupForm = () => {
  const donationFormSettings = useDonationFormContext((state) => state.settings)
  const charityName = useMergeFields((state) => state.mergeFields.get(CharityName.MergeFieldSettingId))
  const campaignName = useMergeFields((state) => state.mergeFields.get(CampaignName.MergeFieldSettingId))
  const { extraFields } = useDonationFormContext((state) => state.formValues)
  const fields: ExtraField[] = useMemo(
    () => donationFormSettings.styles?.options?.callUsFields?.slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
    [donationFormSettings.styles?.options?.callUsFields],
  )

  const { mutateAsync: submitFormValues } = useSubmitFormValuesMutation()

  const onSubmit = async () => {
    const {
      firstName,
      lastName,
      address: fullAddress,
      organisation,
      mobile,
      comment,
      isAnonymous,
      email,
      ...customFields
    } = extraFields ?? {}

    const fieldValues = {
      charityId: usePageStore.getState().charityId,
      formId: donationFormSettings.id,
      formValues: [
        ...(firstName ? [{ name: 'First Name', values: [firstName?.trim()] }] : []),
        ...(lastName ? [{ name: 'Last Name', values: [lastName?.trim()] }] : []),
        ...(organisation ? [{ name: 'Organisation', values: [organisation?.trim()] }] : []),
        ...(fullAddress ? [{ name: 'Address', values: [fullAddress] }] : []),
        ...(mobile ? [{ name: 'Mobile', values: [mobile?.trim()] }] : []),
        ...(comment ? [{ name: 'Message of Support', values: [comment?.trim()] }] : []),
        ...(email ? [{ name: 'Email', values: [email?.trim()] }] : []),
        ...Object.entries(customFields)
          .map(([key, value]: [string, string]) => {
            const customField = fields.find((field) => field.customField?.id === key)
            const values =
              customField?.type === ExtraFieldType.Custom &&
              customField.customField?.elementType === CustomFieldElementType.MultiSelect
                ? value?.trim().split(',')
                : [value?.trim()]

            return {
              customFieldSettingId: key,
              name: customField?.name ?? '',
              values,
            }
          })
          .filter(({ name }) => name !== ''),
      ],
    }

    await submitFormValues(fieldValues)
  }

  return (
    <PageCallUsPopupForm
      charityName={charityName}
      campaignName={campaignName}
      onSubmit={onSubmit}
      Components={{ ProfileSelector }}
    />
  )
}

export default CallUsPopupForm
